import React from "react";
import ReactStreetview from "react-streetview";

const StreetView = (props) => {
  const googleMapsApiKey = process.env.NEXT_PUBLIC_GOOGLE_API;

  // see https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanoramaOptions
  const streetViewPanoramaOptions = {
    position: { lat: parseFloat(props.lat), lng: parseFloat(props.lang) },
    pov: { heading: 100, pitch: 0 },
    zoom: 1,
  };

  return (
    <div
      style={{
        width: "100%",
        height: "87vh",
        backgroundColor: "#eeeeee",
        margin: "0 auto",
      }}
      className="street_popup_cnt"
    >
      <ReactStreetview
        apiKey={googleMapsApiKey}
        streetViewPanoramaOptions={streetViewPanoramaOptions}
      />
    </div>
  );
};
export default StreetView;
